exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* Title */\n.title_style_title__3YKek {\n  padding: 0px 12px;\n  font-size: 1.5em;\n  color: #3d4b60;\n  border-left: 3px #072c82 solid;\n  margin-bottom: 10px;\n  margin-top: 15px;\n  font-weight: bold; }\n\n.title_style_popuptitle__3_tX9 {\n  /* font-size: 18px; */\n  color: white;\n  background: -webkit-linear-gradient(top, #0086da, #072c82);\n  /* background      : -webkit-linear-gradient(top, #f4ece1, #ddd1bb); */\n  background-color: #f4ece1;\n  border-bottom-color: #ddd1bb;\n  width: 100%;\n  padding: 10px;\n  font-weight: bold;\n  font-size: 1.2em; }\n", ""]);

// exports
exports.locals = {
	"title": "title_style_title__3YKek",
	"popuptitle": "title_style_popuptitle__3_tX9"
};